import styled from 'styled-components';
import { tokens } from '../../public/tokens';

const { colors, typography, globals } = tokens;

const bannerVariants = {
    alert: {
        color: colors.states.alert.default,
        background: colors.states.alert['50'],
        borderColor: colors.states.alert['200'],
        backgroundActive: colors.states.alert['100'],
    },
    success: {
        color: colors.states.success['900'],
        background: colors.states.success['100'],
        borderColor: colors.states.success['300'],
        backgroundActive: colors.states.success['300'],
    },
    info: {
        color: colors.states.info.default,
        background: colors.states.info['50'],
        borderColor: colors.states.info['200'],
        backgroundActive: colors.states.info['100'],
    },
    warning: {
        color: colors.states.warning.default,
        background: colors.states.warning['50'],
        borderColor: colors.states.warning['200'],
        backgroundActive: colors.states.warning['100'],
    },
};

/**
 * Full-width inline message above the content it relates to.
 * @param {'alert' | 'success' | 'info' | 'warning'} [$variant] Defaults to alert
 * @param {boolean} [$interactive] Adds a pressed state, for banners wired to onClick
 */
export const Banner = styled.div(({ $variant = 'alert', $interactive }) => ({
    fontFamily: globals['font-family'],
    fontSize: typography.fontSize['lg-14px'],
    color: bannerVariants[$variant].color,
    background: bannerVariants[$variant].background,
    border: `1px solid ${bannerVariants[$variant].borderColor}`,
    borderRadius: globals['border-radius'],
    padding: `${globals['spacing-sm']} ${globals['spacing-md']}`,
    marginBottom: globals['spacing-lg'],
    cursor: $interactive ? 'pointer' : 'inherit',
    transition: 'background-color 0.15s ease',

    ':active': {
        backgroundColor: $interactive ? bannerVariants[$variant].backgroundActive : bannerVariants[$variant].background,
    },
}));
